import React, { useEffect, useState, useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import Moment from 'react-moment';
import TailoringContext from "../../context/TailoringContext";

const DropdownMenu = ({ showNotification, setShowNotification }) => {
  const [notif, setNotif] = useState([]);
  let navigate = useNavigate();
  const { handleGetNotification } = useAuth();

  const {setCustomOrder} = useContext(TailoringContext)

  useEffect(() => {
    handleGetNotification().then((res) => {
      setNotif(res?.data?.custom_order_notification);
      setCustomOrder(res?.data?.custom_order_notification);
    });
    // eslint-disable-next-line
  }, []);

  // console.log("notif ==>", notif);

  return (
    <>
      <Dropdown.Menu>
        <div className="notify_menu">
          <div>
            <p>Notifications</p>

            <Dropdown.Toggle variant="" id="dropdown-basic">
              <p>
                {" "}
                <i className="fa-solid fa-xmark"></i>
              </p>
            </Dropdown.Toggle>
          </div>
          <div>
            <p>New</p>
            {notif?.map((item, idx) => (
              <div key={idx}>
                <p>
                  <span>
                    <Moment format="DD/MM/YYYY">{item?.created_at}</Moment>
                    {/* 18 Aug 2021 */}
                    </span>
                  <span>
                    {/* 09:41 */}
                    <Moment format="hh:mm">{item?.created_at}</Moment>
                    </span>
                </p>
                <p className="text-capitalize">{item?.name}</p>
                <p className="text-capitalize">
                  {item?.desc}
                </p>
                <p
                  onClick={() => {
                    navigate("/tailoring/customorder");
                    setShowNotification(false);
                  }}
                >
                  Pay Now
                </p>
              </div>
            ))}
          </div>
          <div className="older_menu">
            <p>Older</p>
            <div>
              <p>
                <span>18 Aug 2021</span>
                <span>09:41</span>
              </p>
              <p>Changed Password</p>
              <p>You have successfully changed your password</p>
            </div>

            <div>
              <p>
                <span>18 Aug 2021</span>
                <span>09:41</span>
              </p>
              <p>Your Laundry is ready</p>
              <p>Your laundry is ready for pickup</p>
            </div>

            <div>
              <p>
                <span>18 Aug 2021</span>
                <span>09:41</span>
              </p>
              <p>Your cloth has been successfully delivered</p>
              <p>Please rate your experience</p>
            </div>
          </div>
        </div>
      </Dropdown.Menu>
    </>
  );
};

export default DropdownMenu;
